<template>
  <div>
    <Modal
      :id="id"
      no-stacking>
      <template v-slot:modal-title>
        <span class="modal-title">
          <template v-if="purpose === 'cancel'">
            Отмена заказа
          </template>
          <template v-else>
            Закрыть спор
          </template>
        </span>
      </template>
      <template v-slot:default>
        <div class="flex flex-col items-stretch divide-y">
          <div class="flex flex-col space-y-2 p-8">
            <div
              v-for="(penaltyKey, penaltyKeyIndex) in Object.keys(reasons)"
              :key="penaltyKeyIndex"
            >
              <Check
                :label="reasons[penaltyKey].label"
                :value="penalty === penaltyKey"
                @input="onPenaltyChange(penaltyKey)"
              />
            </div>
          </div>
          <div class="flex flex-col space-y-2 p-8">
            <p class="text-center text-16px leading-22px mb-6 text-muted">
              <template v-if="purpose === 'cancel'">
                Пожалуйста оставьте комментарий о причине отмены ниже
              </template>
              <template v-else>
                Пожалуйста оставьте комментарий о причине закрытия спора ниже
              </template>
            </p>
            <Input
              :textarea="true"
              placeholder="Ваш комментарий"
              v-model="comment"
            />
          </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <div class="flex space-x-2">
          <button
            class="btn btn-xs btn-outline-primary flex-grow"
            @click="() => {
              $bvModal.hide(id);
            }">
            Отмена
          </button>
          <button
            class="btn btn-xs btn-primary flex-grow"
            @click="cancel()">
            <template v-if="purpose === 'cancel'">
              Да, отменить
            </template>
            <template v-else>
              Да, закрыть
            </template>
          </button>
        </div>
      </template>
    </Modal>
    <Modal
      id="cancelled"
      :hide-footer="true"
      no-stacking>
      <template v-slot:modal-title>
        <span class="modal-title">Заказ успешно отменен</span>
      </template>
      <template v-slot:default>
        <div class="flex flex-col items-center p-8">
          <p class="text-center text-16px leading-22px mb-6 text-muted">
            Теперь заказ находится на странице “Завершенные” со статусом “отменен”.
          </p>
          <button
            class="btn btn-sm btn-primary"
            @click="$bvModal.hide('cancelled')">
            Понятно
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import _ from 'lodash';
import Modal from '@/components/Modal.vue';
import Check from '@/components/Check.vue';
import Input from '@/components/Input.vue';

// eslint-disable-next-line no-underscore-dangle
const _Reasons = {
  refund0Penalty0Payment1: {
    label: 'Завершение стандартно.',
    customerRefundCoefficient: '0',
    contractorPenaltyCoefficient: '0',
    paymentToContractor: true,
    comment: 'Finalized by admin',
  },
  refund0Penalty30Payment1: {
    label: 'Завершение стандартно, штраф И. 30%',
    customerRefundCoefficient: '0',
    contractorPenaltyCoefficient: '0.30',
    paymentToContractor: true,
    comment: 'Finalized by admin, Contractor penalty 30%',
  },
  refund0Penalty100Payment1: {
    label: 'Завершение стандартно, штраф И. 100%',
    customerRefundCoefficient: '0',
    contractorPenaltyCoefficient: '1.00',
    paymentToContractor: true,
    comment: 'Finalized by admin, Contractor penalty 100%',
  },
  refund0Penalty0Payment0: {
    label: 'Завершение без выплаты И.',
    customerRefundCoefficient: '0',
    contractorPenaltyCoefficient: '0',
    paymentToContractor: false,
    comment: 'Finalized by admin',
  },
  refund0Penalty30Payment0: {
    label: 'Завершение без выплаты И., штраф И. 30%',
    customerRefundCoefficient: '0',
    contractorPenaltyCoefficient: '0.30',
    paymentToContractor: false,
    comment: 'Finalized by admin, No payment, Contractor penalty 30%',
  },
  refund0Penalty100Payment0: {
    label: 'Завершение без выплаты И., штраф И. 100%',
    customerRefundCoefficient: '0',
    contractorPenaltyCoefficient: '1.00',
    paymentToContractor: false,
    comment: 'Finalized by admin, No payment, Contractor penalty 100%',
  },
  refund70Penalty0Payment0: {
    label: 'Отмена с удержанием 30%',
    customerRefundCoefficient: '0.70',
    contractorPenaltyCoefficient: '0',
    paymentToContractor: false,
    comment: 'Cancelled by admin, 30% hold',
  },
  refund70Penalty30Payment0: {
    label: 'Отмена с удержанием 30%, штраф И. 30%',
    customerRefundCoefficient: '0.70',
    contractorPenaltyCoefficient: '0.30',
    paymentToContractor: false,
    comment: 'Cancelled by admin, 30% hold, Contractor penalty 30%',
  },
  refund70Penalty100Payment0: {
    label: 'Отмена с удержанием 30%, штраф И. 100%',
    customerRefundCoefficient: '0.70',
    contractorPenaltyCoefficient: '1.00',
    paymentToContractor: false,
    comment: 'Cancelled by admin, 30% hold, Contractor penalty 100%',
  },
  refund70Penalty0Payment1: {
    label: 'Завершение с удержанием 30%',
    customerRefundCoefficient: '0.70',
    contractorPenaltyCoefficient: '0',
    paymentToContractor: true,
    comment: 'Finalized by admin, 30% hold',
  },
  refund70Penalty30Payment1: {
    label: 'Завершение с удержанием 30%, штраф И. 30%',
    customerRefundCoefficient: '0.70',
    contractorPenaltyCoefficient: '0.30',
    paymentToContractor: true,
    comment: 'Finalized by admin, 30% hold, Contractor penalty 30%',
  },
  refund70Penalty100Payment1: {
    label: 'Завершение с удержанием 30%, штраф И. 100%',
    customerRefundCoefficient: '0.70',
    contractorPenaltyCoefficient: '1.00',
    paymentToContractor: true,
    comment: 'Finalized by admin, 30% hold, Contractor penalty 100%',
  },
  refund100Penalty0Payment0: {
    label: 'Отмена с возвратом 100%',
    customerRefundCoefficient: '1.00',
    contractorPenaltyCoefficient: '0',
    paymentToContractor: false,
    comment: 'Cancelled by admin, 100% refund',
  },
  refund100Penalty30Payment0: {
    label: 'Отмена с возвратом 100%, штраф И. 30%',
    customerRefundCoefficient: '1.00',
    contractorPenaltyCoefficient: '0.30',
    paymentToContractor: false,
    comment: 'Cancelled by admin, 100% refund, Contractor penalty 30%',
  },
  refund100Penalty100Payment0: {
    label: 'Отмена с возвратом 100%, штраф И. 100%',
    customerRefundCoefficient: '1.00',
    contractorPenaltyCoefficient: '1.00',
    paymentToContractor: false,
    comment: 'Cancelled by admin, 100% refund, Contractor penalty 100%',
  },
};

// eslint-disable-next-line no-underscore-dangle
const _ReasonsWithoutContractor = _.pick(_Reasons, [
  'refund100Penalty0Payment0',
  'refund70Penalty0Payment0',
]);

export default {
  props: {
    id: {
      type: String,
      default: 'cancel',
      required: false,
    },
    purpose: {
      type: String,
      default: 'cancel',
      required: false,
    },
    order: {
      required: true,
      validator: (obj) => typeof obj === 'object' || obj === null,
    },
  },
  components: {
    Modal,
    Check,
    Input,
  },
  data() {
    return {
      penalty: null,
      comment: '',
    };
  },
  computed: {
    reasons() {
      if (this.order && this.order.contractor) {
        return _Reasons;
      }
      return _ReasonsWithoutContractor;
    },
  },
  watch: {
    penalty: {
      handler(e) {
        if (e) {
          console.info('<OrderCancelModal> Penalty: ', _Reasons[e]);
          this.comment = _Reasons[e].comment;
        } else {
          console.info('<OrderCancelModal> Penalty: ', null);
          this.comment = '';
        }
      },
    },
  },
  methods: {
    onPenaltyChange(e) {
      if (this.penalty === e) {
        this.penalty = null;
        return;
      }
      this.penalty = e;
    },
    cancel() {
      const p = _Reasons[this.penalty];
      if (!p) return;
      this.$emit('submit', {
        ..._.pick(p, [
          'customerRefundCoefficient',
          'contractorPenaltyCoefficient',
          'paymentToContractor',
        ]),
        comment: this.comment,
      });
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hidden', (event, modalId) => {
      switch (modalId) {
        case 'cancel':
        case 'cancelled':
        case 'close-dispute':
          this.penalty = null;
          this.comment = '';
          break;
        default:
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::hidden');
  },
};
</script>
